import { FormControl, InputLabel } from '@mui/material'
import Container from '@mui/material/Container'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import TextField from '@mui/material/TextField'
import IntakeCard from 'candidate/components/IntakeCard'
import React, { useEffect, useState } from 'react'
import { isValidPhoneNumber } from 'react-phone-number-input'
import NextButton from 'shared/components/NextButton'
import NonFormikPhoneInput from 'shared/components/NonFormikPhoneInput'
import { getPxAsRem } from 'shared/utils'

export interface StafferAnswer {
    firstName: string
    lastName: string
    workTitle: string
    email: string
    phone: string
}
interface Props {
    answer?: StafferAnswer
    callback: React.Dispatch<any>
    workTitles: string[]
    prompt: string
    skipCallback?: React.Dispatch<React.SetStateAction<string>>
    skipText?: string
}

const StafferQuestion: React.FC<Props> = ({
    answer,
    callback,
    workTitles,
    prompt,
    skipCallback,
    skipText,
}: Props) => {
    const [response, setResponse] = useState<StafferAnswer>({
        firstName: answer?.firstName || '',
        lastName: answer?.lastName || '',
        workTitle: answer?.workTitle || '',
        email: answer?.email || '',
        phone: answer?.phone || '',
    })

    const [disabled, setDisabled] = useState<boolean>(true)

    useEffect(() => {
        if (answer) {
            setResponse(answer)
        }
    }, [answer])

    useEffect(() => {
        if (
            response.firstName !== '' &&
            response.lastName !== '' &&
            response.workTitle !== '' &&
            response.email !== '' &&
            (!response.phone ||
                (response.phone !== '' &&
                    isValidPhoneNumber(response.phone ?? '')))
        ) {
            setDisabled(false)
        } else {
            setDisabled(true)
        }
    }, [response])

    const submitData = () => {
        callback({ response })
    }

    return (
        <>
            <IntakeCard
                question={prompt}
                skipCallback={skipCallback}
                skipText={skipText}
            >
                <Container
                    style={{
                        display: 'inline-block',
                        alignContent: 'left',
                        marginBottom: getPxAsRem(36),
                        marginTop: '1rem',
                        padding: '0',
                        width: '100%',
                        maxWidth: '100%',
                    }}
                >
                    <FormControl style={{ marginBottom: '1.5rem' }} fullWidth>
                        <TextField
                            id="firstName"
                            label="First Name"
                            placeholder="First Name"
                            value={response?.firstName}
                            fullWidth
                            onChange={(e) => {
                                setResponse({
                                    ...response,
                                    firstName: e.target.value,
                                })
                            }}
                        />
                    </FormControl>

                    <FormControl style={{ marginBottom: '1.5rem' }} fullWidth>
                        <TextField
                            id="lastName"
                            label="Last Name"
                            placeholder="Last Name"
                            value={response?.lastName}
                            fullWidth
                            onChange={(e) => {
                                setResponse({
                                    ...response,
                                    lastName: e.target.value,
                                })
                            }}
                        />
                    </FormControl>
                    <FormControl style={{ marginBottom: '1.5rem' }} fullWidth>
                        <InputLabel id="title_input">Title</InputLabel>
                        <Select
                            id="title"
                            labelId="title_label"
                            label="Title"
                            value={response?.workTitle}
                            onChange={(e) => {
                                const workTitle =
                                    workTitles.find(
                                        (workTitle: string) =>
                                            workTitle === e.target.value
                                    ) || ''
                                setResponse({ ...response, workTitle })
                            }}
                        >
                            {workTitles.map((workTitle: string) => (
                                <MenuItem key={workTitle} value={workTitle}>
                                    {workTitle}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl style={{ marginBottom: '1.5rem' }} fullWidth>
                        <TextField
                            id="email"
                            label="Email"
                            value={answer?.email}
                            onChange={(e) => {
                                setResponse({
                                    ...response,
                                    email: e.target.value,
                                })
                            }}
                        />
                    </FormControl>
                    <FormControl style={{ marginBottom: '1.5rem' }} fullWidth>
                        <NonFormikPhoneInput
                            id="phone"
                            size="small"
                            value={response.phone}
                            error={
                                (response.phone || '') !== '' &&
                                !isValidPhoneNumber(response.phone)
                                    ? true
                                    : false
                            }
                            helperText={
                                (response.phone || '') !== '' &&
                                !isValidPhoneNumber(response.phone)
                                    ? 'Please provide valid phone no.'
                                    : ''
                            }
                            label="Phone"
                            handleInputChange={(value) => {
                                setResponse({
                                    ...response,
                                    phone: value || '',
                                })
                            }}
                        />
                    </FormControl>
                </Container>
                <NextButton disabled={disabled} onClickHandler={submitData} />
            </IntakeCard>
        </>
    )
}

export default StafferQuestion
